
/**
 * Pick one or more random elements from the given array.
 * @param {String} [required] shelfId - ID for the element where items can be added to the cart
 * @param {String} [required] cartId - ID for the element that will be used as the cart
 * @param {String} [optional] itemsClass - className for the elements that will be copied to cart.
 * @param {String} [optional] addItemClass - className for the button that will add elements to the cart.
 *          Element must be a child of the itemsClass selector
 * @param {String} [optional] removeItemClass - className for the button that will remove items in the cart.
 *          Element must be a child of the itemsClass selector
 * @param {Boolean} [optional] defaultAddBtn - use a default add button containing the string as the button text
 * @param {Boolean} [optional] defaultRemoveBtn - use a default remove button containing the string as the button text
 * @param {Object} [optional] cartMap - optional objects of string -> string relations.
 *          Left string indicates a class of an item
 *          Right string indicates ID of an element in the cart (must be a child element of cartId)
 *          When item with left string class is added to the cart, it will be appended to the right string element with respective ID
 *          Otherwise it will be appended to the root of the cartId element
 * @param {String} [optional] clearCartBtnId - className for the button will clear the cart. Must be child of cartId element.
 * @param {Function} [optional] onUpdate - call back to be called when an update happens.
 */
class ItemCartClass {
  constructor( options = {} ) {
    this._classes = {
      CART_ACTIVE :           'cart-active',
      CART_INACTIVE :         'cart-disabled',
      ITEM_ACTIVE :           'item-active',
      DEFAULT_ADD_BTN :       'itemCartAddBtn',
      DEFAULT_REMOVE_BTN:     'itemCartRemoveBtn'
    };
    this.shelfId =              options.shelfId;
    this.cartId =               options.cartId;
    this.itemsClass =           options.itemsClass ? options.itemsClass : 'itemCart-element';
    this.addItemClass =         options.addItemClass ? options.addItemClass : this._classes.DEFAULT_ADD_BTN;
    this.removeItemClass =      options.removeItemClass ? options.removeItemClass : this._classes.DEFAULT_REMOVE_BTN;
    this.clearCartBtnId =       options.clearCartBtnId;
    this.cartMap =              options.cartMap ? options.cartMap : false;
    this.onUpdateFunc =         options.onUpdateFunc ? options.onUpdateFunc : false;
    this._activeCount =         0;
    this._itemIndex =          "shelf-item-index";
    this._handlersAttached =    false;
    this.transactionsTypes = {
      REMOVE:                   'remove',
      ADD:                      'add',
      CLEAR:                    'clear'
    };
    this._selectors = {
      SHELF :                 `#${this.shelfId}`,
      SHELF_ITEMS :           `#${this.shelfId} .${this.itemsClass}`,
      SHELF_ACTIVE_ITEMS :    `#${this.shelfId} .${this.itemsClass}.${this._classes.ITEM_ACTIVE}`,
      SHELF_INACTIVE_ITEMS :  `#${this.shelfId} .${this.itemsClass}:not(.${this._classes.ITEM_ACTIVE})`,
      CART :                  `#${this.cartId}`,
      CART_ITEMS :            `#${this.cartId} .${this.itemsClass}`,
      ADD_BTNS :              `#${this.shelfId} .${this.addItemClass}, #${this.shelfId} .${this._classes.DEFAULT_ADD_BTN}`,
      REMOVE_BTNS :           `#${this.shelfId} .${this.removeItemClass}, #${this.cartId} .${this.removeItemClass}, #${this.cartId} .${this._classes.DEFAULT_REMOVE_BTN}`,
      CLEAR_BTN :             `#${this.clearCartBtnId}`
    };
    this.defaultAddBtn =        options.defaultAddBtn ? `<button class="${this._classes.DEFAULT_ADD_BTN}">+</button>` : false;
    this.defaultRemoveBtn =     options.defaultRemoveBtn ? `<button class="${this._classes.DEFAULT_REMOVE_BTN}">-</button>` : false;
    this._init();
  }

  _init() {
    this._activeCount = 0;
    let elemCount = 0;
    const that = this;

    $(this._selectors.CART_ITEMS).each(function() {
      $(this).remove();
    });

    $(this._selectors.SHELF_ITEMS).each(function() {
      elemCount++;
      const elem = $(this);
      elem.attr(that._itemIndex, elemCount);
      if(that.defaultAddBtn && !that._handlersAttached){
        elem.append(that.defaultAddBtn);
      }
      if(that.defaultRemoveBtn && !that._handlersAttached){
        elem.append(that.defaultRemoveBtn);
      }
      if(elem.hasClass(that._classes.ITEM_ACTIVE)){
        that._add(elem);
      }
    });
    this._validateClasses();

    if(!this._handlersAttached){
      this._configureHandlers();
      this._handlersAttached = true;
    }
  };

  _configureHandlers(){
    const that = this;
    //add button
    $(document).on("click", this._selectors.ADD_BTNS, function() {
      const elem = $(this).parents(`.${that.itemsClass}`);
      if(elem.length && !elem.hasClass(that._classes.ITEM_ACTIVE)){
        that._add(elem);
      }
    });

    //remove button
    $(document).on("click", this._selectors.REMOVE_BTNS, function() {
      const elem = $(this).parents(`.${that.itemsClass}`);
      if(elem.length && (elem.parents(that._selectors.CART).length || elem.parents(that._selectors.SHELF).length)){
        that._remove(elem);
      }
    });

    //remove button
    if(this.clearCartBtnId){
      $(document).on("click", this._selectors.CLEAR_BTN, function() {
        that._clear();
      });
    }
  }

  _add(elem){
    const cartElem = this._getCartMapping(elem);
    elem.addClass(this._classes.ITEM_ACTIVE);
    elem.clone().appendTo(cartElem);
    this._activeCount++;
    this._validateClasses();
    this._callUpdateFunction(this.transactionsTypes.ADD, elem);
    console.log("added item", elem.attr(this._itemIndex));
  }

  _remove(elem){
    if(elem.hasClass(this._classes.ITEM_ACTIVE)) {
      const index = elem.attr(this._itemIndex);
      $(`${this._selectors.CART} .${this._classes.ITEM_ACTIVE}[${this._itemIndex}=${index}]`).remove();
      $(`${this._selectors.SHELF} .${this._classes.ITEM_ACTIVE}[${this._itemIndex}=${index}]`).removeClass(this._classes.ITEM_ACTIVE);
      this._activeCount--;
      this._validateClasses();
      this._callUpdateFunction(this.transactionsTypes.REMOVE, elem);
      console.log("removed item", elem.attr(this._itemIndex));
    }
  }

  _clear(){
    const that = this;
    $(this._selectors.SHELF_ACTIVE_ITEMS).each(function() {
      that._remove($(this));
    });
    this._callUpdateFunction(this.transactionsTypes.CLEAR, null);
    console.log("cleared items");
  }

  _validateClasses(){
    this._activeCount = this._activeCount < 0 ? 0 : this._activeCount;
    if($(this._selectors.CART_ITEMS).length && this._activeCount > 0){
      $(this._selectors.CART).addClass(this._classes.CART_ACTIVE).removeClass(this._classes.CART_INACTIVE);
      $("body").addClass(this._classes.CART_ACTIVE).removeClass(this._classes.CART_INACTIVE);
    }else{
      $(this._selectors.CART).removeClass(this._classes.CART_ACTIVE).addClass(this._classes.CART_INACTIVE);
      $("body").removeClass(this._classes.CART_ACTIVE).addClass(this._classes.CART_INACTIVE);
    }

    for(const cartIdName in this.cartMap){
      if(this.cartMap.hasOwnProperty(cartIdName)) {
        const selector = `#${this.cartMap[cartIdName]}`;
        if ($(`${selector} .${this.itemsClass}`).length && this._activeCount > 0) {
          $(`${selector}`).addClass(this._classes.CART_ACTIVE).removeClass(this._classes.CART_INACTIVE);
        }else{
          $(`${selector}`).removeClass(this._classes.CART_ACTIVE).addClass(this._classes.CART_INACTIVE);
        }
      }
    }

    console.log("cart count", this._activeCount);
  }

  _callUpdateFunction(transactionType, elem){
    if(this.onUpdateFunc){
      const data = {
        count:      this._activeCount,
        element:    elem,
        transactionType
      };
      this.onUpdateFunc(data);
    }
  }

  _getCartMapping(elem){
    let cartElem = $(this._selectors.CART);
    const that = this;
    const classes = elem.attr("class").split(' ');
    $.each(classes, function(index, className){
      if(that.cartMap.hasOwnProperty(className)){
        const cartIdName = that.cartMap[className];
        const mappedElem = $(`${that._selectors.CART} #${cartIdName}`);
        if(mappedElem.length) {
          cartElem = mappedElem;
        }
      }
    });
    return cartElem;
  }

  render(){
    console.log("re-rendering itemCart");
    this._init();
  }

  /**
   *
   * @returns {jQuery.fn.init|*|Window.jQuery.fn.init|jQuery|HTMLElement}
   * returns a jQuery object of items in the cart
   */
  getCartItems(){
    return $(this._selectors.CART_ITEMS);
  }

  /**
   *
   * @returns {number}
   * returns count for number of items in the cart
   */
  getCount(){
    return this._activeCount;
  }
}

export default function ItemCart(options) {
  if(!options.hasOwnProperty('shelfId')){
    console.error("Unable to initiate ItemCart: shelfId attribute required")
  }else if(!options.hasOwnProperty('cartId')){
    console.error("Unable to initiate ItemCart: cartId attribute required")
  }else {
    return new ItemCartClass(options);
  }
}



// WEBPACK FOOTER //
// ./src/main/js/util/itemCart.js